<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2">{{ $t("views.appointments_admin.appointments") }}</h1>
            <div class="text-right">
                <button
                        class="btn btn-primary btn-action-mobile"
                        @click="showAppointmentsFilterModal"
                >
                    <span class="button-text">Filtri </span>
                    <i class="las la-filter"></i>
                </button>
            </div>

            <ul class="nav nav-tabs margin-bottom-20">
                <li
                        role="presentation"
                        :class="{ active: selectedTab === TAB.UPCOMING }"
                >
                    <a
                            href=""
                            role="tab"
                            data-toggle="tab"
                            @click.prevent.stop="upcomingTabClick"
                    >{{ $t("views.appointments_admin.upcoming") }}</a
                    >
                </li>
                <li role="presentation" :class="{ active: selectedTab === TAB.PAST }">
                    <a
                            href=""
                            role="tab"
                            data-toggle="tab"
                            @click.prevent.stop="pastTabClick"
                    >{{ $t("views.appointments_admin.past") }}</a
                    >
                </li>
            </ul>
            <AppointmentsAdminTable
                    v-if="appointments.length > 0"
                    :appointments="appointments"
                    :in-past="selectedTab === TAB.PAST"
                    @open-partecipants-modal="openPartecipantsModal"
            ></AppointmentsAdminTable>
            <div v-else>
        <span v-if="selectedTab === TAB.UPCOMING" class="text-muted">
          {{ $t("views.appointments_admin.upcoming_not_found") }}</span
        >
                <span v-if="selectedTab === TAB.PAST" class="text-muted">
          {{ $t("views.appointments_admin.past_not_found") }}
        </span>
            </div>
            <div class="text-center">
                <Pagination
                        v-show="numberPagesAppointments > 1"
                        :page-count="numberPagesAppointments"
                        :click-handler="paginateCallback"
                        v-if="enabledPagination"
                />
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <PartecipantsListModal
                v-show="showPartecipantsModal"
                :visible="showPartecipantsModal"
                @close-partecipants-modal="showPartecipantsModal = false"
                :appointment-id="selectedAppointmentId"
        ></PartecipantsListModal>
        <AppointmentsAdminFilterModal
                :visible = showFilterModal
                @close-filter-appointments-modal = 'showFilterModal = false'
                @filter-appointments-callback = "filterCallback"
                @remove-filter-appointments-callback = "filterCallback">
        </AppointmentsAdminFilterModal>
    </ContainerWithMenu>
</template>

<script>
import ContainerWithMenu from "../components/container/ContainerWithMenu";
import SpinnerLoader from "../components/common/SpinnerLoader";
import {LIMIT_RECORDS_API} from "../common/constants";
import {
    getMyAppointmentsFromToday,
    getMyAppointmentsUntilToday
} from "../api";
import {Utils} from "../common/utils";
import AppointmentsAdminTable from "../components/appointment/AppointmentsAdminTable";
import i18n from "../i18n";
import Pagination from "../components/common/Pagination";
import AppointmentsAdminFilterModal from "../components/modal/AppointmentsAdminFilterModal";
import PartecipantsListModal from "../components/modal/PartecipantsListModal";
import {StorageHelper} from "../common/storageHelper";

export default {
    title: i18n.t("views.appointments_admin.appointments"),
    name: "Appointments",
    components: {
        ContainerWithMenu,
        SpinnerLoader,
        Pagination,
        AppointmentsAdminTable,
        PartecipantsListModal,
        AppointmentsAdminFilterModal
    },
    data: function () {
        return {
            selectedTab: 0,
            TAB: {
                UPCOMING: 0,
                PAST: 1
            },
            filter: {
                date: null,
                admin: null,
                rate: null,
            },
            appointments: [],
            showFilterModal: false,
            countAppointments: 0,
            limitAppointments: LIMIT_RECORDS_API,
            currentPageAppointments: 1,
            loading: false,
            showPartecipantsModal: false,
            selectedAppointmentId: 0,
            enabledPagination: true
        };
    },
    mounted() {
        this.filter.admin = StorageHelper.getUser().id;
        this.getAppointments(1, this.filter);
    },
    methods: {
        upcomingTabClick() {
            this.selectedTab = this.TAB.UPCOMING;
            this.getAppointments(1, this.filter);
        },
        pastTabClick() {
            this.selectedTab = this.TAB.PAST;
            this.getAppointments(1, this.filter);
        },
        paginateCallback(pageNum) {
            this.getAppointments(pageNum,this.filter);
        },
        filterCallback(filter){
            this.filter = filter;
            this.getAppointments(1,this.filter);
            this.enabledPagination = false;
            this.$nextTick(() => {
                this.enabledPagination = true;
            });
        },
        async getAppointments(page = 1, filter) {
            this.loading = true;
            try {
                switch (this.selectedTab) {
                    case this.TAB.UPCOMING: {
                        let appointmentFromTodayResponse = await getMyAppointmentsFromToday(
                                page, filter
                        );
                        this.countAppointments = appointmentFromTodayResponse.count;
                        this.saveAppointmentsWithSeparator(appointmentFromTodayResponse);
                        break;
                    }
                    case this.TAB.PAST: {
                        let appointmentUntilTodayResponse = await getMyAppointmentsUntilToday(
                                page, filter
                        );
                        this.countAppointments = appointmentUntilTodayResponse.count;
                        this.saveAppointmentsWithSeparator(appointmentUntilTodayResponse);
                        break;
                    }
                }
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.log(e);
            }
        },
        openPartecipantsModal(appointmentId) {
            this.selectedAppointmentId = appointmentId;
            this.showPartecipantsModal = true;
        },

        showAppointmentsFilterModal(){
            this.showFilterModal = true
        },

        saveAppointmentsWithSeparator(appointmentsResponse) {
            const appointmentsResult = appointmentsResponse.results;
            let appointmentsWithSeparators = [];

            for (let i = 0; i < appointmentsResult.length; i++) {
                if (i === 0) {
                    appointmentsWithSeparators.push({
                        separator: true,
                        separator_name: Utils.getBeatifyShortDateStringFromISO(
                                appointmentsResult[i].date
                        )
                    });
                } else if (
                        new Date(appointmentsResult[i].date).setHours(0, 0, 0, 0) !==
                        new Date(appointmentsResult[i - 1].date).setHours(0, 0, 0, 0)
                ) {
                    appointmentsWithSeparators.push({
                        separator: true,
                        separator_name: Utils.getBeatifyShortDateStringFromISO(
                                appointmentsResult[i].date
                        )
                    });
                }
                appointmentsWithSeparators.push(appointmentsResult[i]);
            }
            this.appointments = appointmentsWithSeparators;
        }
    },
    computed: {
        numberPagesAppointments: function () {
            return Utils.getNumberPageByCountLimit(
                    this.countAppointments,
                    this.limitAppointments
            );
        }
    }
};
</script>
